// extracted by mini-css-extract-plugin
export var buttonContent = "_3f-0";
export var centered = "_3f-1";
export var centeredFlex = "_3f-2";
export var errorText = "_3f-3";
export var icon = "_3f-4";
export var iconButtonContent = "_3f-5";
export var monospace = "_3f-6";
export var padded = "_3f-7";